import type { CategoryStyle } from './categoryStyle';

export function CategoryIcon({ style, size = 18 }: { style: CategoryStyle; size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={style.icon} />
    </svg>
  );
}
